import React from 'react';

const CalendarIcon = (): JSX.Element => {
	return <span className="fIcon icon-appointment1"></span>;
};

export default CalendarIcon;
